<template>
    <div class="empty-row text-center p-3">
        <svg width="34px" height="34px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg> 
        <span class="pl-2">{{noResults}}</span></div>
</template>

<script>
    export default {
        name: 'mmTablaEmpty',
        data() {
            return {                
                noResults: 'No hay resultados para mostrar'
            }
        },
        props: ['noResultsProp'],
        created() {            
            if (this.noResultsProp != undefined) this.noResults = this.noResultsProp;
        }
    }
</script>